import { Menu as BaseMenu } from '@base-ui/react/menu'

import { cn } from '@gto/ui/cn'

import { menuItemVariants } from './item.styles'

/**
 * Menu row that renders as an `<a>` (or any `render`-provided element) and
 * navigates on click. Identical styling to `Menu.Item`; use this when the row
 * is a navigation link rather than a button-style action.
 */
export const LinkItem = ({ className, ...props }: BaseMenu.LinkItem.Props) => {
  return (
    <BaseMenu.LinkItem
      className={cn(menuItemVariants(), className)}
      {...props}
    />
  )
}
